import React, { useState } from 'react';

const FormFilling = () => {
  // State for the single, comprehensive form
  const [formData, setFormData] = useState({
    certificateTypes: {
      domicile: false,
      caste: false,
      income: false,
    },
    name_hi: '',
    name_en: '',
    fatherName_hi: '',
    fatherName_en: '',
    motherName_hi: '',
    motherName_en: '',
    dob: '',
    mobile: '',
    address: '',
    photo: '', // Will store the base64 string of the image
    casteCategory: '', // General, OBC, SC, ST
    caste: '', // This will now be for sub-caste
    incomeSource: '',
    residencePeriod: 'janm_se', // 'janm_se' or 'dinank_se'
    residenceDate: '',
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [serialNumber, setSerialNumber] = useState('');

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      certificateTypes: { ...prev.certificateTypes, [name]: checked },
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prev => ({ ...prev, photo: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const generateSerialNumber = () => {
    const now = new Date();
    const datePart = `${now.getDate().toString().padStart(2, '0')}${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getFullYear()}`;
    const timePart = `${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;
    const randomPart = Math.floor(Math.random() * 9000) + 1000;
    return `${datePart}-${timePart}-${randomPart}`;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newSerialNumber = generateSerialNumber();
    const submissionData = {
      ...formData,
      serialNumber: newSerialNumber,
      submissionDate: new Date().toISOString(),
      status: 'pending',
    };

    const existingApplications = JSON.parse(localStorage.getItem('applications')) || [];
    localStorage.setItem('applications', JSON.stringify([...existingApplications, submissionData]));

    setSerialNumber(newSerialNumber);
    setFormSubmitted(true);
  };

  if (formSubmitted) {
    return (
      <div className="max-w-2xl mx-auto text-center py-10 px-4">
        <h2 className="text-3xl font-bold text-green-600 mb-4">आवेदन सफलतापूर्वक जमा हुआ!</h2>
        <p className="text-lg text-gray-700 mb-2">आपका आवेदन जमा हो गया है। ग्राम प्रधान द्वारा अनुमोदन की प्रतीक्षा करें।</p>
        <p className="text-lg font-semibold text-gray-800">आपका सीरियल नंबर है:</p>
        <p className="text-2xl font-bold text-blue-600 bg-blue-50 p-3 rounded-lg inline-block my-4">{serialNumber}</p>
        <p className="text-md text-gray-600">कृपया भविष्य के संदर्भ के लिए इस नंबर को नोट कर लें।</p>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-3xl font-bold text-center mb-6 text-gray-800">एकीकृत प्रमाण पत्र आवेदन पत्र</h1>
      <form onSubmit={handleSubmit} className="space-y-6">

        {/* Certificate Type Selection */}
        <div className="p-4 border rounded-md">
          <h2 className="text-lg font-semibold mb-2">1. प्रमाण पत्र का प्रकार चुनें</h2>
          <div className="flex flex-wrap gap-4">
            <label className="flex items-center space-x-2"><input type="checkbox" name="domicile" checked={formData.certificateTypes.domicile} onChange={handleCheckboxChange} className="h-5 w-5"/><span>निवास प्रमाण पत्र</span></label>
            <label className="flex items-center space-x-2"><input type="checkbox" name="caste" checked={formData.certificateTypes.caste} onChange={handleCheckboxChange} className="h-5 w-5"/><span>जाति प्रमाण पत्र</span></label>
            <label className="flex items-center space-x-2"><input type="checkbox" name="income" checked={formData.certificateTypes.income} onChange={handleCheckboxChange} className="h-5 w-5"/><span>आय प्रमाण पत्र</span></label>
          </div>
        </div>

        {/* Personal Details */}
        <div className="p-4 border rounded-md">
          <h2 className="text-lg font-semibold mb-3">2. व्यक्तिगत विवरण (हिन्दी में नाम अनिवार्य है)</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input type="text" name="name_hi" placeholder="आवेदक का नाम (हिंदी) *" value={formData.name_hi} onChange={handleInputChange} required className="p-2 border rounded-md"/>
            <input type="text" name="name_en" placeholder="Applicant's Name (English)" value={formData.name_en} onChange={handleInputChange} className="p-2 border rounded-md"/>
            <input type="text" name="fatherName_hi" placeholder="पिता का नाम (हिंदी) *" value={formData.fatherName_hi} onChange={handleInputChange} required className="p-2 border rounded-md"/>
            <input type="text" name="fatherName_en" placeholder="Father's Name (English)" value={formData.fatherName_en} onChange={handleInputChange} className="p-2 border rounded-md"/>
            <input type="text" name="motherName_hi" placeholder="माता का नाम (हिंदी) *" value={formData.motherName_hi} onChange={handleInputChange} required className="p-2 border rounded-md"/>
            <input type="text" name="motherName_en" placeholder="Mother's Name (English)" value={formData.motherName_en} onChange={handleInputChange} className="p-2 border rounded-md"/>
          </div>
        </div>
        
        {/* Photo and DOB */}
        <div className="p-4 border rounded-md">
            <h2 className="text-lg font-semibold mb-3">3. फोटो और जन्मतिथि</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">आवेदक का फोटो (वैकल्पिक)</label>
                    <input type="file" name="photo" accept="image/*" onChange={handleFileChange} className="p-2 border rounded-md w-full"/>
                    {formData.photo && <img src={formData.photo} alt="Applicant Preview" className="mt-2 h-24 w-24 object-cover rounded-md"/>}
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">जन्म तिथि (Date of Birth) *</label>
                    <input type="date" name="dob" value={formData.dob} onChange={handleInputChange} required className="p-2 border rounded-md w-full"/>
                </div>
            </div>
        </div>

        {/* Other Details */}
        <div className="p-4 border rounded-md">
          <h2 className="text-lg font-semibold mb-3">4. अन्य विवरण</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <select name="casteCategory" value={formData.casteCategory} onChange={handleInputChange} className="p-2 border rounded-md">
                <option value="">-- जाति श्रेणी चुनें --</option>
                <option value="General">सामान्य (General)</option>
                <option value="OBC">अन्य पिछड़ा वर्ग (OBC)</option>
                <option value="SC">अनुसूचित जाति (SC)</option>
                <option value="ST">अनुसूचित जनजाति (ST)</option>
            </select>
            <input type="text" name="caste" placeholder="उप-जाति (Sub-caste)" value={formData.caste} onChange={handleInputChange} className="p-2 border rounded-md"/>
            <input type="text" name="incomeSource" placeholder="आय का साधन (Source of Income)" value={formData.incomeSource} onChange={handleInputChange} className="p-2 border rounded-md"/>
            <input type="text" name="mobile" placeholder="मोबाइल नंबर *" value={formData.mobile} onChange={handleInputChange} required className="p-2 border rounded-md"/>
            <select name="residencePeriod" value={formData.residencePeriod} onChange={handleInputChange} className="p-2 border rounded-md">
              <option value="janm_se">निवास जन्म से है</option>
              <option value="dinank_se">दिनांक से है</option>
            </select>
            {formData.residencePeriod === 'dinank_se' && (
              <input type="date" name="residenceDate" value={formData.residenceDate} onChange={handleInputChange} required className="p-2 border rounded-md"/>
            )}
          </div>
        </div>

        <button type="submit" className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-blue-700 focus:outline-none">
          आवेदन जमा करें
        </button>
      </form>
    </div>
  );
};

export default FormFilling;
